module.exports = __webpack_public_path__ + "img/gas-station-night-thumb.d2bd27fa.jpg";